module.exports = __webpack_public_path__ + "static/assets/25502419a22e241873dc7e4c46325713.svg";